export const STORE = 'entities/auth/STORE';
export const CLEAR = 'entities/auth/CLEAR';
export const REFETCH_USER = 'entities/auth/REFETCH_USER';
